export default __webpack_public_path__ + "/dist/images/banner-video.ffadf8781ff80c783c473630955b527b.mp4";